import React, { Component } from 'react'
import { connect } from 'react-redux'

import t from 'tcomb-form'
import I18n from '../../i18n/i18n'
import ContentCard from '../../Components/UI/ContentCards/ContentCard'
import FormCard from '../../Components/UI/ContentCards/FormCard'
import styles from '../../Components/Styles/Screens/Forms'
import BillingInfoForm from './Forms/BillingInfoForm'
import { Metrics } from '../../Themes'

import UserActions from '../../Redux/UserRedux'

class ProfileScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: {
        displayName: ''
      }
    }
  }

  componentDidMount() {
    const { user } = this.props
    this.setState({
      value: {
        displayName: user?.displayName || ''
      }
    })
  }

  getFields = () => {
    return {
      displayName: t.String
    }
  }

  getFieldsOptions = () => {
    return {
      displayName: {
        label: I18n.t('shared.displayName')
      }
    }
  }

  onFormChange = (value) => {
    this.setState({ value })
  }

  onFormSubmit = () => {
    const { user } = this.props
    const { value } = this.state
    const updatedValue = {
      ...(user?.displayName !== value.displayName && { displayName: value.displayName })
    }
    this.props.updateUserValue(user, updatedValue)
  }

  saveUser = (value) => {
    this.props.saveUser(this.props.user, { address: value } )
  }

  render = () => {
    return (
      <div style={{
        ...styles.mainBody,
        marginBottom: Metrics.doubleBaseMargin,
        height: 'calc(100vh - 100px)',
        width: '100%',
        maxWidth: '800px',
        overflow: 'auto'
      }}>
        <ContentCard
          renderContent={() => (
            <>
              <FormCard
                title={I18n.t('shared.generalSettings')}
                name={'displayNameForm'}
                onSubmit={this.onFormSubmit}
                onChange={this.onFormChange}
                deleteButton={false}
                fields={this.getFields()}
                fieldsOptions={this.getFieldsOptions()}
                value={this.state.value}
                fetching={this.props.fetching}
              />
            </>
          )}
        />
        <BillingInfoForm
          user={this.props.user}
          fetching={this.props.fetching}
          onSubmit={this.saveUser}
        >
        </BillingInfoForm>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    fetching: state.user.fetching
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserValue: (user, fields) => dispatch(UserActions.userSaveRequest(user, fields)),
    saveUser: (user, fields) => dispatch(UserActions.userSaveRequest(user, fields))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileScreen)